import { useNavigate, useParams } from 'react-router-dom';
import { useMutation } from '@apollo/client';
import { Formik } from 'formik';
import Button from '../components/Button';
import { Field, FieldInput, FieldLabel } from '../components/Field';
import { Modal, ModalExit, ModalName, ModalPart } from '../components/Modal';
import { useToast } from '../components/Toast';
import { createTagCache } from '../utilities/cache';
import { CREATE_TAG } from '../utilities/mutations';

const NewTagModal = () => {
  const navigate = useNavigate();
  const params = useParams();
  const toast = useToast();
  const [createTag] = useMutation(CREATE_TAG);

  const close = () => navigate(`/s/${params.s}/settings/tags`);

  return (
    <Modal onClose={() => close()}>
      <ModalExit />
      <ModalName>New tag</ModalName>
      <Formik
        initialValues={{ name: '' }}
        onSubmit={async (values) => {
          try {
            await createTag({
              variables: {
                name: values.name,
                spaceSlug: params.s,
              },
              update: (cache, { data: { createTag } }) =>
                createTagCache(params.s, cache, createTag),
            });
          } catch (error) {
            toast({ children: error.message });

            return;
          }

          toast({ children: `${values.name} tag created` });
          close();
        }}
      >
        {({ values, handleChange, handleBlur, handleSubmit, isSubmitting }) => (
          <form onSubmit={handleSubmit}>
            <ModalPart>
              <Field>
                <FieldLabel>Tag name</FieldLabel>
                <FieldInput
                  type="text"
                  name="name"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.name}
                  data-autofocus
                />
              </Field>
            </ModalPart>
            <ModalPart>
              <Button
                type="submit"
                disabled={values.name === '' || isSubmitting}
                isPrimary
                isExtended
              >
                Create
              </Button>
            </ModalPart>
          </form>
        )}
      </Formik>
    </Modal>
  );
};

export default NewTagModal;
